import { Box } from 'enova-frontend-components';
import { Controller, useWatch } from 'react-hook-form';
import { FC } from 'react';

import { EnumRadioButton } from '../../heating/components/enumRadioButton';
import { JaNeiVetIkke, VentilasjonsType } from '../../../../../utils/registerEnums';
import { YearNumberField } from '../../general/components/yearNumberField';
import { ServiceRadio } from '../../heating/components/serviceRadio';
import { AboutFormControlProps } from '../../types';
import { SelectableAreaWrapper } from '../../heating/components/checkboxArea';

import { VarmegjenvinnerSelect } from './varmegjenvinnerSelect';
import { GjenvinningAvVarmeRadioGroup } from './gjenvinningAvVarmeRadio';

export const BalansertVentilasjonRadioButton: FC<AboutFormControlProps> = ({ control }) => {
  const ventilasjonsType = useWatch({
    control,
    name: 'ventilasjon.ventilasjonType'
  });

  const gjenvinningAvVarme = useWatch({
    control,
    name: 'ventilasjon.gjenvinningAvVarme'
  });

  const isBalansertVentilasjon = ventilasjonsType === VentilasjonsType.Balansert;

  const hasGjenvinningAvVarme = gjenvinningAvVarme === JaNeiVetIkke.Ja;

  return (
    <SelectableAreaWrapper isSelected={isBalansertVentilasjon} pt={isBalansertVentilasjon ? 4 : 2}>
      <EnumRadioButton hasHelperText i18nPrefix="register.ventilation.option" value={VentilasjonsType.Balansert} />

      {isBalansertVentilasjon && (
        <Box>
          <Controller
            name="ventilasjon.installasjonsAr"
            control={control}
            render={({ field, fieldState }) => (
              <YearNumberField
                value={field.value}
                error={fieldState.error}
                onChange={field.onChange}
                informationKey="register.tekniskUtstyr.ventilasjon.installasjonsAr.information"
              />
            )}
          />
          <Controller
            name="ventilasjon.serviceGjennomfortSiste2Ar"
            control={control}
            render={({ field, fieldState }) => (
              <ServiceRadio
                value={field.value}
                i18nPrefix="register.tekniskUtstyr.ventilasjon.serviceGjennomfortSiste2Ar"
                onChange={field.onChange}
                error={fieldState.error}
              />
            )}
          />
          <GjenvinningAvVarmeRadioGroup control={control} />

          {hasGjenvinningAvVarme && (
            <Box m={3}>
              <VarmegjenvinnerSelect control={control} />
            </Box>
          )}
        </Box>
      )}
    </SelectableAreaWrapper>
  );
};
